<template>
  <div class="out-of-office">
    <div class="row">
      <div class="col s12 m8">
        <div class="user-collection" v-if="currentListsX">
          <div class="user-items" v-for="(member, index) in currentListsX" :key="index">
            <div class="user-avatar">
              <i class="material-icons-outlined">account_circle</i>
            </div>
            <div class="user-name"></div>
            <div class="status"></div>
            <div class="date-range">

            </div>
          </div>
        </div>
      </div>
      <div class="col s12 m4">
        <div class="user-lists">
          <ul class="user-collection">
            <li v-for="user in staff" :key="user.id">
              <div class="user">
                  <!-- <p> -->
                    <label>
                    <input type="checkbox" v-model="selectedStaff" :value="user"/>
                    <span v-html="user.name"></span>
                    </label>
                  <!-- </p> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
const getStaffList = async () => {
  const {data} = await axios.get('http://localhost:2700/staff/all')
  return data
}
const getCurrentLists = async () => {
  const {data} = await axios.get('http://localhost:2700/staff/current-status')
  return data
}
export default {
  name:'OutOfOffice',
  data () {
    return {
      staff: [],
      selectedStaff: [],
      currentLists: false,
      ready: false
    }
  },
  async mounted() {
    this.staff = await getStaffList()
    if(this.staff.length > 0) this.ready = true 
    this._fetchCurrentLists()
  },
  computed:{
    currentListsX:{
      get () {
        if (this.currentLists.length > 0) {
        return this.currentLists.map(x => {
          return {
            ...x,
            name: this.staff.find(staff => staff.id === x.id ? staff.name : '').name
          }
        })
        } else {
          return false
        }

      }
    }
  },
  methods:{
    async _fetchCurrentLists () {
      const data = await getCurrentLists()
      this.currentLists = data
    }
  },
  
}
</script>